import React, { Component } from 'react';
import Permission from './permission';

const Enhancer = (config) => (
  (WrappedComponent) => (
    class WithPermission extends Component {
      constructor(props) {
        super(props);

        let args;
        if (typeof config === 'function') {
          args = config(props);
        } else {
          args = config;
        }

        this.state = { args };
      }
      render() {
        const { args } = this.state;
        const { propName, permissions, grantPermissions } = args;

        return (
          <Permission permissions={permissions} grantPermissions={grantPermissions}>
            {({ hasPermission }) => (
              <WrappedComponent
                {...this.props}
                {...(propName ? { [propName]: hasPermission } : { hasPermission })}
              />
            )}
          </Permission>
        );
      }
    }
  )
);

export default Enhancer;



// WEBPACK FOOTER //
// ./src/components/permission/withPermissionValidation.js